import script from "./BeneficiaryCalendarModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeneficiaryCalendarModal.vue?vue&type=script&setup=true&lang=ts"

import "./BeneficiaryCalendarModal.vue?vue&type=style&index=0&id=776e6be0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-776e6be0"]])

export default __exports__